const schemeInfoAgainstInvestorReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_SCHEME_INFO_AGAINST_INVESTOR":
          return state;
      case "SET_SCHEME_INFO_AGAINST_INVESTOR" :
          return action.info;
      case "NULL_SCHEME_INFO_AGAINST_INVESTOR" :
          return action.info;
      default:
          return state;
    }
  }
  export default schemeInfoAgainstInvestorReducer